/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Asset, Asset$inboundSchema } from "./asset.js";

export type ListAssetsResult = {
  /**
   * The list of assets
   */
  assets: Array<Asset>;
};

/** @internal */
export const ListAssetsResult$inboundSchema: z.ZodMiniType<
  ListAssetsResult,
  unknown
> = z.object({
  assets: z.array(Asset$inboundSchema),
});

export function listAssetsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAssetsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAssetsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAssetsResult' from JSON`,
  );
}
